
const FortuneBackground = () => {
  return (
    <div className="absolute inset-0 -z-10 opacity-5">
      <div className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full bg-yellow-500 filter blur-3xl"></div>
      <div className="absolute bottom-1/3 right-1/3 w-96 h-96 rounded-full bg-orange-300 filter blur-3xl"></div>
    </div>
  );
};

export default FortuneBackground;
